import { render } from "./CatalogCart.vue?vue&type=template&id=370f8310&scoped=true"
import script from "./CatalogCart.vue?vue&type=script&lang=js"
export * from "./CatalogCart.vue?vue&type=script&lang=js"

import "./CatalogCart.vue?vue&type=style&index=0&id=370f8310&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-370f8310"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
